const UserPermissionsDomainActionTypes = {
  USER_PERMISSIONS_DOMAIN: 'user/permissionsDomain',
};

export default UserPermissionsDomainActionTypes;
